import React from "react";

interface TestimonialCardProps {
    data: {
        name: string;
        role: string;
        clinicName: string;
        avatar: string;
        quote: string;
    };
}

export default function TestimonialCard({ data }: TestimonialCardProps) {
    return (
        <div
            className={`rounded-2xl bg-bg-page p-8 transition-all duration-300 ease-out opacity-100 shadow-md
      `}
        >
            {/* Quote */}
            <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                <img src={data.avatar} alt={data.name} className="h-24 w-24 rounded-full object-cover" />

                <div>
                    <p className="text-lg tracking-tight text-text-secondary">{data.quote}</p>
                    <div className="mt-6">
                        <p className="font-medium text-text-primary">{data.name}</p>
                        <p className="text-sm text-text-muted">
                            {data.role}
                            {data.clinicName && ` • ${data.clinicName}`}
                        </p>
                    </div>
                </div>
            </div>

            {/* Author */}
        </div>
    );
}
